import locale from './menuLanguage';
export default {
    // menu: [{
    //     'mainTitle': locale.sellerMenu.sellerCurrentPosition,
    //     'link': '/seller.html#/',
    //     'type': 'Group', // 没有子菜单
    //     'alias': 'personalCenter',
    //     'id': 99
    // }],
    seller: [{
            'mainTitle': locale.sellerMenu.sellerCurrentPosition, // 当前位置
            'link': '/seller.html#/',
            'type': 'Group', // 没有子菜单
            'alias': 'personalCenter',
            'id': 99
        },
        {
            'mainTitle': locale.sellerMenu.seller, // 卖家
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 100,
            'pid': 99
        },
        {
            'mainTitle': locale.sellerMenu.personalCenter,
            'id': 101,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/personalCenter',
            'menuKey': 'personalCenter'
        },
        {
            'mainTitle': locale.sellerMenu.logisticsPlan,
            'id': 102,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/logisticsPlan',
            'menuKey': 'logisticsPlan'
        },
        {
            'mainTitle': locale.sellerMenu.logisticsTracking,
            'id': 103,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/logisticsTracking',
            'menuKey': 'logisticsTracking'
        },
        {
            'mainTitle': locale.sellerMenu.logisticsReconciliation, // 物流对账
            'secondMenu': 'second-menu',
            'id': 104,
            'pid': 100
        },
        {
            'mainTitle': locale.sellerMenu.logisticsReconciliation, // 物流对账
            'menuKey': 'logisticsReconciliation',
            'link': '/seller.html#/logisticsReconciliation',
            'id': 105,
            'pid': 104
        },
        {
            'mainTitle': locale.sellerMenu.logisBillManage, // 物流账单管理
            'menuKey': 'logisBillManage',
            'link': '/seller.html#/logisBillManage',
            'id': 106,
            'pid': 104
        },
        {
            'mainTitle': locale.sellerMenu.logisticsProvider,
            'id': 107,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/logisticsProvider',
            'menuKey': 'logisticsProvider'
        },
        {
            'mainTitle': locale.sellerMenu.logisticsChannel,
            'id': 108,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/logisticsChannel',
            'menuKey': 'logisticsChannel'
        },
        {
            'mainTitle': locale.sellerMenu.logisticsDetails,
            'id': 109,
            'icon': '',
            'pid': 100,
            'link': '/seller.html#/logisticsDetails',
            'menuKey': 'logisticsDetails'
        },
        {
            'mainTitle': locale.sellerMenu.overseasWarehouse, // 海外仓
            'secondMenu': 'second-menu',
            'id': 110,
            'pid': 100
        },
        {
            'mainTitle': locale.sellerMenu.overseasWarehouseDtl, // 海外仓详情
            'menuKey': 'overseasWarehouseDetails',
            'link': '/seller.html#/overseasWarehouseDetails',
            'id': 111,
            'pid': 110
        },
        {
            'mainTitle': locale.sellerMenu.overseasWarehouseInvent, // 海外仓库存
            'menuKey': 'overseasWarehouseInventory',
            'link': '/seller.html#/overseasWarehouseInventory',
            'id': 112,
            'pid': 110
        },
        {
            'mainTitle': locale.sellerMenu.overseasWarehouseBill, // 海外仓账单
            'menuKey': 'overseasWarehouseBill',
            'link': '/seller.html#/overseasWarehouseBill',
            'id': 113,
            'pid': 110
        }
    ]
};


// WEBPACK FOOTER //
// ./src/api/menuSeller.js